/**
 * Give - Stripe Gateway Payment Request JS
 */

let stripe = Stripe( give_stripe_vars.publishable_key );
if ( give_stripe_vars.stripe_account_id ) {
	stripe = Stripe( give_stripe_vars.publishable_key, { stripeAccount: give_stripe_vars.stripe_account_id } );
}

document.addEventListener( 'DOMContentLoaded', function() {

	// Get all the donation forms on a single page.
	const formWraps       = document.querySelectorAll( '.give-form-wrap' );
	let prButton          = [];
	let paymentRequest    = [];
	let isPRButtonExists  = [];
	let defaultGateway    = '';
	const preferredLocale = give_stripe_vars.preferred_locale;

	// Loop through each donation form.
	Array.prototype.forEach.call( formWraps, function( formWrap ) {

		let form_element = formWrap.querySelector( '.give-form' );

		let elements = stripe.elements({
			locale: preferredLocale,
		});

		if ( null !== form_element.querySelector( '.give-gateway-option-selected .give-gateway').value ) {
			defaultGateway = form_element.querySelector( '.give-gateway-option-selected .give-gateway').value;
		}

		let idPrefix = form_element.getAttribute('data-id');

		// Set default value for payment request button exists flag.
		isPRButtonExists[idPrefix] = false;

		// Set default gateway value on changing gateway.
		Array.prototype.forEach.call( form_element.querySelectorAll( '.give-gateway' ), function( gateway_element ) {
			gateway_element.addEventListener( 'change', function( e ) {
				if ( gateway_element.checked ) {
					defaultGateway = gateway_element.value;
				}
			});
		});

		// Prepare tabs and payment request button on gateway load.
		jQuery( document ).on( 'give_gateway_loaded', function( event, xhr, settings ) {
			if ( defaultGateway === 'stripe' ) {
				prepareStripeCCTabs();
				preparePaymentRequestButton( idPrefix, elements );
			}
		});

		// Trigger build tabs custom event when required.
		function prepareStripeCCTabs() {
			const tabElements = form_element.querySelectorAll( 'ul.give-stripe-payment-tabs li a' );

			// Bailout, if tabElements doesn't exists.
			if ( null === tabElements ) {
				return;
			}

			// Payment Tabs to support Google/Apple Pay.
			Array.prototype.forEach.call( tabElements, function( tabElement ) {
				const purchaseSubmit       = form_element.querySelector( '.give-submit-button-wrap' );
				const paymentRequestSubmit = form_element.querySelector( '.give-stripe-payment-request-content' );
				const errorElement         = form_element.querySelector( '#give-stripe-payment-errors-' + idPrefix );

				purchaseSubmit.style.display = 'block';
				paymentRequestSubmit.style.display = 'none';

				tabElement.addEventListener( 'click', function( e ) {
					const currentParentTag = this.parentElement;
					const currentElementID = form_element.querySelector( this.getAttribute( 'href' ) );

					Array.prototype.forEach.call( tabElements, function( tab ) {
						const currentTab = form_element.querySelector( tab.getAttribute( 'href' ) );

						// Reset tabs and its content.
						currentTab.style.display = 'none';
						tab.parentElement.className = '';
					} );

					// Reset error on switching tabs.
					errorElement.innerHTML = '';

					// Hide standard donate button when Google or Apple Pay is displayed.
					if ( '#give-stripe-payment-request-content' === this.getAttribute( 'href' ) ) {
						purchaseSubmit.style.display = 'none';
						paymentRequestSubmit.style.display = 'block';

						// Create a new hidden field is_payment_request, if if it doesn't exist.
						if ( ! form_element.querySelector( 'input[name="is_payment_request"]') ) {
							const isPaymentRequestFlag = document.createElement( 'input' );
							isPaymentRequestFlag.setAttribute( 'type', 'hidden' );
							isPaymentRequestFlag.setAttribute( 'name', 'is_payment_request' );
							isPaymentRequestFlag.setAttribute( 'value', true );
							form_element.appendChild( isPaymentRequestFlag );
						}

					} else if ( '#give-stripe-credit-card-content' === this.getAttribute( 'href' ) ) {
						paymentRequestSubmit.style.display = 'none';
						purchaseSubmit.style.display = 'block';

						// Remove the hidden field "is_payment_request" used as flag.
						form_element.querySelector( 'input[name="is_payment_request"]').remove();
					}

					// Display active tab content.
					currentElementID.style.display = 'block';

					// Add active class to clicked tab.
					currentParentTag.className = ( ! currentParentTag.classList.contains( 'active' ) ) ? currentParentTag.classList + 'active' : currentParentTag.classList;

					// Prevent user from redirection.
					e.preventDefault();
				} );
			} );
		}

		/**
		 * Prepare Payment Request Button.
		 *
		 * @param {string} idPrefix ID Prefix.
		 * @param {object} elements Stripe Elements Object.
		 *
		 * @since 1.6
		 */
		function preparePaymentRequestButton( idPrefix, elements ) {

			let formName = form_element.querySelector( 'input[name="give-form-title"]' );
			let donationAmount = Give.fn.unFormatCurrency( form_element.querySelector( '.give-final-total-amount' ).dataset.total, form_element.dataset.decimal_separator );

			paymentRequest[ idPrefix ] = stripe.paymentRequest( {
				country: give_stripe_vars.base_country,
				currency: form_element.getAttribute('data-currency_code').toLowerCase(),
				total: {
					label: formName.value,
					amount: Math.round( donationAmount * 100 ),
				},
				requestShipping: false,
				requestPayerName: true,
			} );

			if ( false === isPRButtonExists[idPrefix] ) {

				prButton[ idPrefix ] = elements.create(
					'paymentRequestButton',
					{
						paymentRequest: paymentRequest[ idPrefix ],
						style: {
							paymentRequestButton: {
								type: 'donate',
								theme: give_stripe_vars.payment_request_button_style,
								height: '64px',
							},
						},
					}
				);

				isPRButtonExists[ idPrefix ] = true;
			}

			// Check the availability of the Payment Request API first.
			paymentRequest[ idPrefix ]
				.canMakePayment()
				.then( function( result ) {
					let paymentRequestButton = document.getElementById( 'give-stripe-payment-request-button-' + idPrefix);

					if ( paymentRequestButton ) {
						if ( result ) {
							prButton[ idPrefix ].mount( '#give-stripe-payment-request-button-' + idPrefix );
							isPRButtonExists[ idPrefix ] = true;
						}
						paymentRequestButton.style.display = 'block';
					}
				} );

			paymentRequest[ idPrefix ].on( 'source', async( ev ) => {
				form_element.querySelector( 'input[name="give_stripe_source"]' ).value = ev.source.id;
				form_element.querySelector( 'input[name="card_address"]' ).value = ev.source.owner.address.line1;
				form_element.querySelector( 'input[name="card_address_2"]' ).value = ev.source.owner.address.line2;
				form_element.querySelector( 'input[name="card_city"]' ).value = ev.source.owner.address.city;
				form_element.querySelector( 'input[name="card_zip"]' ).value = ev.source.owner.address.postal_code;

				autoSelectCountry( ev.source.owner.address.country );
				autoSelectState( ev.source.owner.address.country, ev.source.owner.address.state );

                setTimeout(() => {
                    form_element.submit();
                    ev.complete( 'success' );
                }, 2000 );

			} );

			prButton[ idPrefix ].on( 'click', function( evt ) {

				let verifyPayment = new XMLHttpRequest();
				let formData      = new FormData( form_element );
				let errorElement  = form_element.querySelector( '#give-stripe-payment-errors-' + idPrefix );
				donationAmount = Give.fn.unFormatCurrency( form_element.querySelector( '.give-final-total-amount' ).dataset.total, form_element.dataset.decimal_separator );

				formData.append( 'action', 'give_process_donation' );
				formData.append( 'give_ajax', true );

				paymentRequest[ idPrefix ].update( {
					currency: form_element.getAttribute( 'data-currency_code' ).toLowerCase(),
					total: {
						label: formName.value,
						amount: Math.round( donationAmount * 100 ),
					},
				} );

				// Do something on Ajax on state change.
				verifyPayment.onreadystatechange = function() {

					if (
						4 === this.readyState &&
						200 === this.status &&
						'success' !== this.responseText
					) {
						evt.preventDefault();
						errorElement.innerHTML = this.response;
					} else {
						errorElement.innerHTML = '';
					}

				};
				verifyPayment.open( 'POST', give_global_vars.ajaxurl, false );
				verifyPayment.send( formData );
			} );
		}

		// Load custom events when default gateway is stripe on load.
		if ( 'stripe' === defaultGateway ) {
			prepareStripeCCTabs();
			preparePaymentRequestButton( idPrefix, elements );
		}

		/**
		 * This function is used to dynamically select the country.
		 *
		 * @param {string} country Name of the country.
		 *
		 * @since 2.2.0
		 */
		function autoSelectCountry( country ) {

			const element = form_element.querySelector( 'select[name="billing_country"]' );
			const option  = element.getElementsByTagName( 'option' );

			for ( let i = 0; i < option.length; i++ ) {
				option[i].selected = false;
				option[i].removeAttribute( 'selected' );
				if ( option[i].value === country){
					option[i].selected = true;
					option[i].setAttribute( 'selected', 'selected' );
				}
			}
			// return null;
		}

		/**
		 * This function is used to dynamically select the states based on country.
		 *
		 * @param {string} country Name of the Country.
		 * @param {string} state   Name of the State.
		 *
		 * @since 2.2.0
 		 */
		function autoSelectState( country, state ) {

            const updateStates = new XMLHttpRequest();
            let formData       = new FormData();

            formData.append( 'action', 'give_get_states' );
            formData.append( 'country', country );
            formData.append( 'field_name', 'card_state' );

            // Do something on Ajax on state change.
            updateStates.onreadystatechange = function() {

                if (
                    4 === this.readyState &&
                    200 === this.status &&
                    'success' !== this.responseText
                ) {
                    const response = JSON.parse( this.response );
                    const selectElementWrap = form_element.querySelector( '#give-card-state-wrap' );
                    selectElementWrap.querySelector( 'select[name="card_state"]' ).remove();

                    selectElementWrap.innerHTML = selectElementWrap.innerHTML + response.data;

					const element = form_element.querySelector( 'select[name="card_state"]' );
					const option  = element.getElementsByTagName( 'option' );

					for ( let i = 0; i < option.length; i++ ) {
						option[i].selected = false;
						option[i].removeAttribute( 'selected' );
						
						if ( option[i].value === state || option[i].textContent === state ){
							option[i].selected = true;
							option[i].setAttribute( 'selected', 'selected' );
						}
					}

                }

            };
            updateStates.open( 'POST', give_global_vars.ajaxurl, false );
            updateStates.send( formData );

		}


	} );
} );



// WEBPACK FOOTER //
// ./assets/src/js/frontend/give-stripe-payment-request.js